import React, { useEffect, useState } from "react";

const Commandes = () => {
  const [commandes, setCommandes] = useState([]);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("commandes")) || [];
    setCommandes(data);
  }, []);

  return (
    <div style={{ padding: "2rem", backgroundColor: "#f8f5ef", minHeight: "auto" }}>
      <div style={{ textAlign: "center" }}>
        <h1 style={{ color: "#1f1f1f", fontSize: "2.5rem" }}>Vos commandes</h1>
        <p style={{ fontSize: "1rem", color: "#666" }}>
          * Seules les commandes passées à partir de votre appareil actuel sont affichées ici.
        </p>
      </div>

      <div style={{ overflowX: "auto", marginTop: "2rem" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "#fff" }}>
          <thead>
            <tr style={{ backgroundColor: "#e0e0e0", textAlign: "left" }}>
              <th style={thStyle}>Référence</th>
              <th style={thStyle}>Date</th>
              <th style={thStyle}>Montant</th>
              <th style={thStyle}>État</th>
              <th style={thStyle}>Transporteur</th>
            </tr>
          </thead>
          <tbody>
            {commandes.length === 0 ? (
              <tr>
                <td colSpan="8" style={{ textAlign: "center", padding: "1rem", color: "#888" }}>
                  Aucune commande enregistrée.
                </td>
              </tr>
            ) : (
              commandes.map((cmd, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={tdStyle}>{cmd.id}</td>
                  <td style={tdStyle}>{cmd.date}</td>
                  <td style={tdStyle}>{cmd.montant} €</td>
                  <td style={tdStyle}>{cmd.etat}</td>
                  <td style={tdStyle}>{cmd.transporteur}</td>
                  <td style={tdStyle}>{cmd.numeroSuivi || "-"}</td>
                  <td style={tdStyle}>{cmd.commentaire || "-"}</td>
                  <td style={tdStyle}>{cmd.facture || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <a href="/" style={buttonStyle}>Retour</a>
      </div>
    </div>
  );
};

const thStyle = { padding: "10px", fontWeight: "bold", borderBottom: "2px solid #ccc" };
const tdStyle = { padding: "10px", verticalAlign: "top" };
const buttonStyle = {
  display: "inline-block",
  padding: "0.8rem 1.5rem",
  backgroundColor: "#204b57",
  color: "#fff",
  borderRadius: "5px",
  textDecoration: "none",
};
const linkStyle = { color: "#4a8aa6", textDecoration: "none", margin: "0 5px" };

export default Commandes;
